import humanize from 'humanize-string'
import titleize from 'titleize'

export default {
  data () {
    return {
      // Default visible statuses. Mostly used for paged lists.
      defaultStatuses: [
        'pending', 'send_confirmation',
        'completed', 'created', 'other'
      ],

      statuses: [
        'canceled', 'canceled_reversal', 'completed', 'created',
        'declined', 'expired', 'failed', 'in_progress',
        'partially_refunded', 'pending', 'processed',
        'refunded', 'reversed', 'send_confirmation', 'voided',
        'lapsed'
      ]
    }
  },

  methods: {
    statusName (status) {
      return titleize(humanize(status))
    },

    statusClasses (status) {
      let className = 'dark'

      switch (status) {
        case 'pending':
          className = 'warning'
          break
        case 'send_confirmation':
          className = 'primary'
          break
        case 'completed':
          className = 'success'
          break
        case 'created':
          className = 'info'
          break
      }

      return `purchase badge badge-${className}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/PurchaseMixin.js